const reformatOktaGroupString = (groups: string): string => {
  const groupNames = groups
    .substring(1, groups.length - 1)
    .split(",")
    .filter((s) => s.length > 0)
    .map((g) => `"${g.trim()}"`);

  if (groupNames.length === 0) {
    return "[]";
  }

  return `[${groupNames.join(",")}]`;
};
export const parseOktaGroups = (groups: string): string[] => {
  // NOTE: Okta group names are formatted similar to the following: [\"Everyone\",\"Okta_SSO_NRRS_TEST\",\"RRS_DEV_Data\",\"RRS_DEV_ITReadOnly\"]
  // The okta groups string _may_ sometimes also be missing quoted group names: [Everyone, INTERNAL_FullAccess, RRS_TEST_Data, Salesforce Users, Data%2C+Rights+%26+Allocations, Okta_SSO_WRS_Admin]

  let groupString = groups;

  // Simple guard against inputs that aren't JSON Arrays
  if (groupString.length === 0 || groupString === "[]" || !(groupString.startsWith("[") && groupString.endsWith("]"))) {
    return [];
  }

  // NOTE: We generally expect groups to already be formatted as an escaped JSON array,
  // however some Okta users have shown to have strings with no quotes so in order to handle
  // both cases, we need to support splitting by comman and wrapping each value with Double Quotes
  const containsQuotes = groups.includes('"');
  if (!containsQuotes) {
    groupString = reformatOktaGroupString(groupString);
  }

  return JSON.parse(groupString);
};

export const extractOktaGroups = (userAttributes: { [key: string]: string }): string[] => {
  const groups: string[] = [];

  const oktaGroups = parseOktaGroups(userAttributes["custom:groups"] || "[]");

  if (Array.isArray(oktaGroups)) {
    for (const group of oktaGroups as string[]) {
      // TODO: [NRRS-578] This needs to check that the Okta group's environment is also the current one
      // This extracts the role name from the end component of the group name
      // In other words, it extracts the string 'Data' from 'RRS_DEV_Data'
      const name = group.match(/[A-Za-z]+$/);
      if (group.startsWith("RRS_") && name) {
        groups.push(name[0]);
      }
    }
  }

  return groups;
};
